/**
 * app()
 * Build the Angular App
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */


/**
 * Pull Angular and Angular Resource into the JS Codebase
 */
window.angular = require('angular');
require('angular-animate');
require('angular-loading-bar');
require('angular-resource');
/**
 * Pull Angular Directive for checklist models
 * @see : https://vitalets.github.io/checklist-model/
 */
require('checklist-model');

/**
 * Attach services to Application
 * Services allouw us to register API Resources
 */
require('./flsServices');

/**
 * Require Controllers
 * Controllers hangle JS logic
 */
require('./flsControllers');

/**
 * Require Config
 * Configulation
 */
require('./flsConfig');
